module.exports = __webpack_public_path__ + "static/media/arrow-left.3fa60254.svg";